import { render } from "./PARTY_UPDATED_NAME_CONSOLIDATED.vue?vue&type=template&id=3f4deeb0"
import script from "./PARTY_UPDATED_NAME_CONSOLIDATED.vue?vue&type=script&lang=js"
export * from "./PARTY_UPDATED_NAME_CONSOLIDATED.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__